import { useEffect, useState, useContext } from 'react';
import { BoardContext, TableContext, TeamContext, UserContext } from "../../../context";
import { RenderEmotionalCardType, RenderSocialCardType, RenderMentalCardType, RenderPhysicalCardType, RenderJokerSolutionCardType } from '../MyBoard/subMyBoardComponents';
import { ArrowButton, PinkNotification } from '../../atoms';
import { useWindowDimensions } from '../../../hooks';
import { IPlayer } from '../../../interfaces';

import blueHands from "../../../assets/avatars/avatarsHands/handsPlayerBlue.png";
import pinkHands from "../../../assets/avatars/avatarsHands/handsPlayerPink.png";
import yellowHands from "../../../assets/avatars/avatarsHands/handsPlayerYellow.png";
import greenHands from "../../../assets/avatars/avatarsHands/handsPlayerGreen.png";
import { CardType, Phase } from '../../../util/enums';
import { useTranslation } from 'react-i18next';

const CardsInHandMolecule = () => {
    const { t } = useTranslation();
    const { width } = useWindowDimensions();
    const { userData, setEmailOfSelectedPlayerBoard, playersInNewOrder } = useContext(UserContext);
    const { game } = useContext(TeamContext);
    const { instructionTutorial } = useContext(BoardContext);
    const { 
        userAngles, 
        areAnimatedHandsShown, 
        setAreAnimatedHandsShown, 
        isEmotionalCardVisible, 
        isSocialCardVisible, 
        isMentalCardVisible, 
        isPhysicalCardVisible, 
        theIndexOfTheUserPositionedAt270Degrees, 
        updateUserAngles, 
        areAvatarsCurentlyResting 
    } = useContext(TableContext);

    const [playerOn270Degrees, setPlayerOn270Degrees] = useState<IPlayer>({
        color: game?.players.find((player: IPlayer) => { return player.email === userData?.email })?.color || "pink",
        fullName: "",
        nickname: "",
        email: "",
        image: "",
        isReady: true
    });
    const [cardTypeThatWasProposed, setCardTypeThatWasProposed] = useState<CardType | string>("");
    const initialScreenWidthInPixels = 1500;
    const onePercentageOfBrowserWidth = width / initialScreenWidthInPixels;
    const scale_percentage_of_hands = 0.8;
    const scalability_percentage = onePercentageOfBrowserWidth * scale_percentage_of_hands;
    const isTheUserDilemaOwner = userData?.email === game?.gameInfo.currentPlayerEmail;
    let move_hands_from_bottom = `-${10 / onePercentageOfBrowserWidth}px`;

    if (!areAnimatedHandsShown) {
        move_hands_from_bottom = "-350px";
    }

    useEffect(() => {
        if (game?.players)
            setPlayerOn270Degrees(playersInNewOrder[theIndexOfTheUserPositionedAt270Degrees]);
    }, [game, userAngles, theIndexOfTheUserPositionedAt270Degrees, playersInNewOrder])

    useEffect(() => {
        let listOfProposedCards: any = game?.gameInfo?.proposedSolutionCards;
        if(listOfProposedCards[userData?.email || ""] ){
            let proposedCardOfTheUser: any = listOfProposedCards[userData?.email || ""]

            switch(proposedCardOfTheUser.type){
                case "Joker": setCardTypeThatWasProposed(CardType.JOKER_SOLUTION); break;
                case "Emotional": setCardTypeThatWasProposed(CardType.EMOTIONAL_SOLUTION); break;
                case "Relations": setCardTypeThatWasProposed(CardType.SOCIAL_SOLUTION); break;
                case "Mental": setCardTypeThatWasProposed(CardType.MENTAL_SOLUTION); break;
                case "Physical": setCardTypeThatWasProposed(CardType.PHYSICAL_SOLUTION);
            }
        }else{
            setCardTypeThatWasProposed("");
        }
    }, [game?.gameInfo?.proposedSolutionCards, userData?.email] );

    if (!playerOn270Degrees) {
        return <div></div>
    }

    const getZIndexForShowYourCardsButotnWhenBlueModalIsShown = () => {
        if ( game?.phase === Phase.SOLUTION_CHOSEN ) return 8;
        if ( game?.phase === Phase.SOLUTION_CHOSEN_REWARD ) return 8;
        if ( game?.phase === Phase.RENDER_SPIN_WHEEL ) return 8;
        if ( (game?.phase === Phase.PICK_DILEMMA && isTheUserDilemaOwner) ) return 8;
        if ( game?.phase === Phase.CHOOSING_SOLUTION_CARDS ) return 9;
        if ( game?.phase === Phase.PICK_DILEMMA ) return 8;

        return 11;
    }

    const displayCardsInHands = () => {
        return (
            <div className="cards_in_hand center_horizontally_and_vertically">

                <div className="cards_in_hands_helper">
                    {`${isEmotionalCardVisible}`}, 
                    {`${isSocialCardVisible}`}, 
                    {`${isMentalCardVisible}`}, 
                    {`${isPhysicalCardVisible}`}
                </div>

                <div className={`cards_in_hand__holder joker_in_hands ${cardTypeThatWasProposed === "Joker" ? "dim_proposed_solution_card" : ""}`} >
                    <RenderJokerSolutionCardType />
                </div>
                {!isEmotionalCardVisible && instructionTutorial === "solutionCards" && 
                    <div className={`cards_in_hand__holder emotional_in_hands_introduction cursor_disable_click`} >
                        <RenderEmotionalCardType isForceHoverOn={true}/>
                    </div>}
                {!isEmotionalCardVisible && <div className={`cards_in_hand__holder emotional_in_hands ${cardTypeThatWasProposed === "Emotional" ? "dim_proposed_solution_card" : ""}`} >
                    <RenderEmotionalCardType />
                </div>}
                {isEmotionalCardVisible && <div className="cards_in_hand__holder_visibility_hidden emotional_in_hands"> </div>}
                {!isSocialCardVisible && <div className={`cards_in_hand__holder social_in_hands ${cardTypeThatWasProposed === "Relations" ? "dim_proposed_solution_card" : ""}`} >
                    <RenderSocialCardType />
                </div>}
                {isSocialCardVisible && <div className="cards_in_hand__holder_visibility_hidden social_in_hands"> </div>}
                {!isMentalCardVisible && <div className={`cards_in_hand__holder mental_in_hands ${cardTypeThatWasProposed === "Mental" ? "dim_proposed_solution_card" : ""}`} >
                    <RenderMentalCardType />
                </div>}
                {isMentalCardVisible && <div className="cards_in_hand__holder_visibility_hidden mental_in_hands"> </div>}
                {!isPhysicalCardVisible && <div className={`cards_in_hand__holder physical_in_hands ${cardTypeThatWasProposed === "Physical" ? "dim_proposed_solution_card" : ""}`} >
                    <RenderPhysicalCardType />
                </div>}
                {isPhysicalCardVisible && <div className="cards_in_hand__holder_visibility_hidden physical_in_hands"> </div>}
            </div>
        )
    }

    const getHandsColor = () => {
        switch (playerOn270Degrees.color) {
            case "pink":
                return pinkHands;
            case "yellow":
                return yellowHands;
            case "blue":
                return blueHands;
            case "green":
                return greenHands;
        }
        return "";
    }

    const playersHands = () => {
        return (
            <div >
                <img className="hands" src={getHandsColor()} alt="hands" />
            </div>

        );
    }

    const toggleAnimatedHands = () => {
        setAreAnimatedHandsShown(!areAnimatedHandsShown);
        playersInNewOrder.forEach((player: IPlayer, index: number) => {
            if (player.email === userData?.email) {
                updateUserAngles(index);
                setEmailOfSelectedPlayerBoard(player.email);
            }
        })
    }

    return (
        <div className="center_horizontally_and_vertically" style={{ width: "100%", height: "100%", overflow: "hidden" }}>
            
            <div className="show_your_cards_button_wrapper" style={{ zIndex: getZIndexForShowYourCardsButotnWhenBlueModalIsShown()}}>
                <div style={{position: "relative"}}>
                    <div className="show_your_cards_button_holder">
                        <ArrowButton
                            arrowVwHeight={5}
    					    arrowVwWidth={5}
                            arrowDirection="vertical"
                            toolTipText={t("cardsAndHandsText")}
                            tipSide="left"
                            clickHandler={toggleAnimatedHands}
                            isTheDivShown={!areAnimatedHandsShown}
                            disabled={!areAvatarsCurentlyResting}
                        />
                    </div>
                </div>
            </div>

            <div className="hands_molecule_overflow_hidden_wrapper" style={{zIndex: getZIndexForShowYourCardsButotnWhenBlueModalIsShown()}}>
                <div className="center_horizontally" >
                    <div className={`hands_molecule__wrapper animated_hands_shown`} style={{ transform: `scale(${scalability_percentage})`, bottom: `${move_hands_from_bottom}` }} >
                        
                        <div style={{ position: "absolute", bottom: 0, width: "50%", borderRadius: "500px", height: "90%", zIndex: 11 }}></div>
                        {playersHands()}
                        {displayCardsInHands()}
                    </div>
                </div>
            </div>
            
        </div>
    );
}

export default CardsInHandMolecule;
